<template>
    <div id="reports-list">
        <router-view />
    </div>
</template>

<script>
// import UrlApi from "@/utils/UrlApi.js";
export default {
    name:"ReportsList",
    data () {
        return {
            
        };
    },
    methods: {

    }
}

</script>
<style lang="less" scoped>
    #reports-list {
        width: 100%;
        margin: 0 auto;
        min-height: calc(100vh - 145px);
    }
</style>